import { UseDataQuery, UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { GetAbilitiesResponse } from '../../../modules/users/ability.types';
import {
  getFindAdminUserTeamsKey,
  getFindTeamsKey,
  getGetAbilitiesKey,
  getGetTeamKey,
} from './users.keys';
import { findAdminUserTeams, findTeams, getAbilities, getTeam } from './users.repository';
import { GetTeamOutput, GetTeamsOutput } from './users.types';

export const useGetTeam = ({
  teamId,
  ...options
}: Pick<UseDataQuery, 'teamId'> & UseDataQueryOptions = {}) =>
  useDataQuery<GetTeamOutput>(
    {
      teamId,
      queryKey: getGetTeamKey(),
      queryFn: async () => {
        const res = await getTeam();

        if (!res.ok) {
          throw res.originalError;
        }

        return res.data;
      },
    },
    options,
  );

export const useFindTeams = (options: UseDataQueryOptions = {}) =>
  useDataQuery<GetTeamsOutput | undefined>(
    {
      queryKey: getFindTeamsKey(),
      queryFn: async () => {
        const res = await findTeams({
          skip: 0,
          limit: 1000,
        });

        if (!res.ok) {
          throw res.originalError;
        }

        return res.data;
      },
    },
    options,
  );

export const useFindAdminUserTeams = (
  userId: string | undefined,
  options: UseDataQueryOptions = {},
) =>
  useDataQuery<GetTeamsOutput | undefined>(
    {
      queryKey: getFindAdminUserTeamsKey(userId ?? ''),
      queryFn: async () => {
        const res = await findAdminUserTeams(userId ?? '', {
          skip: 0,
          limit: 1000,
        });

        if (!res.ok) {
          throw res.originalError;
        }

        return res.data;
      },
    },
    options,
  );

export const useGetAbilities = ({
  teamId,
  ...options
}: Pick<UseDataQuery, 'teamId'> & UseDataQueryOptions = {}) =>
  useDataQuery<GetAbilitiesResponse>(
    {
      teamId,
      queryKey: getGetAbilitiesKey(),
      queryFn: async () => {
        const response = await getAbilities();

        return { data: response.data, ok: response.ok, status: response.status };
      },
    },
    options,
  );
